var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTelegram = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.368 10.014.095-.043c.545-.24 1.098-.464 1.649-.689.03 0 .08-.032.108-.043l.128-.052.245-.1.49-.2.982-.398L8.03 7.69l1.963-.797 1.964-.798L13.92 5.3c.145-.06.303-.148.459-.174.13-.022.258-.065.39-.089.25-.045.526-.063.765.036.083.034.16.082.223.142.304.286.261.754.197 1.156l-1.344 8.393c-.061.384-.145.805-.464 1.048-.27.205-.654.228-.988.141s-.627-.271-.916-.452l-3.591-2.258c-.285-.178-.601-.412-.598-.736.001-.196.124-.37.25-.524 1.04-1.288 2.54-2.174 3.657-3.402.157-.174.281-.486.065-.586-.129-.06-.276.02-.394.098l-4.426 2.92c-.482.317-.986.644-1.567.722-.519.07-1.041-.068-1.544-.208a79 79 0 0 1-1.26-.362c-.223-.066-.453-.137-.625-.286s-.27-.399-.167-.597c.065-.125.192-.203.324-.268z"
  })));
};
export default SvgIcTelegram;